// extracted by mini-css-extract-plugin
module.exports = {"failure-inner":"failure_failure-inner__2w913","failure-title":"failure_failure-title__2QZRj"};